import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useLocation } from 'react-router-dom';
import config from '../../constants';

export const useGoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize(config.GOOGLE_ANALYTICS_KEY as string);
    ReactGA.pageview(location.pathname);
  }, [location.pathname, config.GOOGLE_ANALYTICS_KEY]);

  return null;
};
